import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { useShadowRoot, watch } from 'vue';
import 'shepherd.js/dist/css/shepherd.css';
import { i18n } from '@/localization/localization';

import '@/ce/index.css';
import App from './App.vue';
import { LocaleEnum } from './enums/Locale.enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'App.ce',
  props: {
    ngProps: {}
  },
  setup(__props: any) {

const props = __props;

const shadowRoot = useShadowRoot();

// Watch for language changes from parent app
watch(
	() => props.ngProps,
	async (newNgProps) => {
		const { language } = newNgProps ?? {};
		if (!language) return;

		const isLanguageValid = Object.values(LocaleEnum).includes(language);
		if (!isLanguageValid) return;

		(i18n.global as any).locale.value = language;
	},
	{ immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("html", null, [
    _createElementVNode("body", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(App, {
          "shadow-root": _unref(shadowRoot) || null
        }, null, 8, ["shadow-root"])
      ])
    ])
  ]))
}
}

})